import React, { useEffect, useState } from "react";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import Sidebar from "../../directives/sidebar";
import DataTable, { createTheme } from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import config from "../../coreFIles/config";
import {
  getAllUserTransactionList,
} from "../../Action/action";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import customStyles from "../CustomStyles";

createTheme("lightTheme", {
  palette: {
    mode: "light",
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
    background: {
      default: "#ffffff",
    },
    divider: "#cccccc",
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      hover: "rgba(0, 0, 0, 0.08)",
      disabled: "rgba(0, 0, 0, 0.12)",
    },
  },
});

const tableContainerStyle = {
  // maxHeight: '600px',
  border: "1px solid #ddd",
  borderRadius: "4px",
};

const TokenPurchaseHistory = () => {
  const [searchText, setSearchText] = useState("");
  const [usersTransactionList, setUsersTransactionList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const columns = [
    {
      name: "S.No",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
      width: "100px",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.userName,
      sortable: true,
      center: true,
      // width: "90px",
    },
    {
      name: "amount",
      cell: (row) => row.amount + ' ' + config.tokenSymbol,
      center: true,
      // width: "90px",
    },
    {
      name: "Eth Amount",
      selector: (row) => parseFloat(row.EthAmount).toFixed(6) + ' ETH',
      center: true,
      // width: "150px",
    },
    {
      name: "Wallet Address",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <span title={row.walletAddress}>
            {row?.walletAddress?.slice(0, 6)}...{row?.walletAddress?.slice(-4)}
          </span>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopy(row.walletAddress, "Wallet Address")}
          >
            <i className="fa fa-copy"></i>
          </button>
        </div>
      ),
      center: true,
      width: "200px",
    },
    {
      name: "Tx Hash",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <span title={row.txHash}>
            {row?.txHash?.slice(0, 6)}...{row?.txHash?.slice(-4)}
          </span>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopy(row.txHash, "Transaction Hash")}
          >
            <i className="fa fa-copy"></i>
          </button>
        </div>
      ),
      width: "200px",
      center: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(row.createdAt).format("DD/MM/YY"),
      center: true,
      width: "200px",
    },


  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true);
        const res = await getAllUserTransactionList();
        setUsersTransactionList(res.data);
        setFilteredData(res.data);
      } catch (error) {
        console.error("Error fetching SPV list:", error);
        toast.error("Failed to load SPV list");
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (searchText) {
      const filtered = usersTransactionList.filter((item) =>
        Object.values(item).some(
          (val) =>
            val &&
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(usersTransactionList);
    }
  }, [searchText, usersTransactionList]);


  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copied!`);
  };



  return (
    <div className="wrapper">
      <Toaster />
      <Header />
      <Sidebar />
      <div
        className="content-wrapper"
        style={{ Height: "auto", minHeight: "100%" }}
      >
        <div className="container-full">
          <section className="content">
            <div className="row">
              <div className="col-lg-12 col-12">
                <div className="box">
                  <div className="box-header with-border d-flex justify-content-between align-items-center">
                    <h3 className="box-title" style={{ fontWeight: 600 }}>
                      Users Token Purchase History
                    </h3>
                    {/* <Link to={`${config.baseUrl}addSpv`}>
                      <button className="btn btn-primary">Add SPV+</button>
                    </Link> */}
                  </div>

                  <div className="box-body">
                    <div className="row mb-3 justify-content-end">
                      <div className="col-md-5 col-lg-4 col-xl-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row mb-3" style={{ display: "none" }}>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Users..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </div>
                    </div>
                    {loader ? (
                      <div className="text-center py-5">
                        <h4>
                          <i className="fa fa-spinner fa-spin"></i> &nbsp;
                          Please wait
                        </h4>
                      </div>
                    ) : (
                      <div
                        className="table-responsive"
                        style={tableContainerStyle}
                      >
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          pagination
                          highlightOnHover
                          theme="lightTheme"
                          customStyles={customStyles}
                          fixedHeader
                          onChangePage={(page) => setCurrentPage(page)}
                          onChangeRowsPerPage={(
                            currentRowsPerPage,
                            currentPage
                          ) => {
                            setRowsPerPage(currentRowsPerPage);
                            setCurrentPage(currentPage);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default TokenPurchaseHistory;
